import Foundation from './modules/foundation';
import Carousel from './modules/carousel';
import AOS from './modules/aos';
import Magnific from './modules/magnific';
import Header from './modules/header';

$(document).ready(() => {
    Foundation.setup();
    AOS.setup();
    Magnific.setup();
    Header.setup();

    const searchToggle = document.querySelector(".search__toggle")
    const searchDiv = document.querySelector(".header__search")
    if (searchToggle) {
        searchToggle.addEventListener("click", () => {
            searchDiv.classList.toggle("header__search--active")
        })
    }

    // stops scrolling when hamburger menu is active
    const offCanvas = document.querySelector(".off-canvas")
    const offCanvasWrapper = document.querySelector(".off-canvas-wrapper")

    const onMenuToggle = () => {
        if (offCanvas.classList.contains("is-open")) {
            const x = window.scrollX
            const y = window.scrollY
            window.onscroll = () => window.scrollTo(x, y)
        } else {
            window.onscroll = () => {}
        }
    }

    const mutationObserver = new MutationObserver(onMenuToggle)
    mutationObserver.observe(offCanvas, { attributes: true })

    Carousel.setup('.banner', {
        delay: true,
        prevArrow: '<i class="fal fa-chevron-left"></i>',
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        arrows: true,
    });

    Carousel.setup('.product__imageSingle', {
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'ease-out',
    });

    Carousel.setup('.product__imageNav', {
        prevArrow: '<i class="fal fa-chevron-left"></i>',
        nextArrow: '<i class="fal fa-chevron-right"></i>',
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        cssEase: 'ease-out',
    });

    $('.product__imageSingle').on('afterChange', function(event, slick, currentSlide) {
        $('.product__imageNav').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.product__imageNav .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.product__imageNav .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.product__imageNav').on('click', '.slick-slide', function(event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.product__imageSingle').slick('slickGoTo', goToSingleSlide);
    });

    /**
     * Add Sliders below 
     */

    const saleStyleChange = function() {
        const saleSpan = document.querySelector('.onsale')
        const url = document.URL
        const urlCheck = /product-category/
        if (urlCheck.test(url) === true) {
            saleSpan.style.top = '35px'
            console.log(saleSpan.style)
        }
    }
    saleStyleChange()
});